import React from 'react';
import Sidebar from "../sidebar";
import Navbar from "../navbar";
import { Routes, Route } from 'react-router-dom';
import TableList from './tableList';
import Command from './command';

function Caisse() {
    return (
        <div className="min-h-screen flex bg-[#F9F9F9]">
            <div className="fixed lg:relative lg:flex">
                <Sidebar />
            </div>
            <div className="flex-1">
                <Navbar />
                <div className="flex-1 ml-0 lg:ml-64 p-4">
                    <Routes>
                        <Route path="/" element={<TableList />} />
                        <Route path="/:id" element={<Command />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
}
export default Caisse;